import { useState } from "react";
import {
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";

const FaqSection = () => {
  const [active, setActive] = useState(0);

  const faqs = [
    {
      question:
        "What construction services do you provide?",
      answer:
        "We provide residential construction, commercial construction, renovation, turnkey projects, and complete project management services.",
    },
    {
      question:
        "Do you provide property buying and selling assistance?",
      answer:
        "Yes. Our property dealer services help clients buy, sell, and invest in residential and commercial properties with professional guidance.",
    },
    {
      question:
        "Do you handle government approvals and documentation?",
      answer:
        "Yes. Through our liaisoning services, we assist with approvals, permissions, legal documentation, and coordination with relevant authorities.",
    },
    {
      question:
        "How long does a construction project take?",
      answer:
        "Project timelines depend on the size and complexity of the project. After consultation, we provide a detailed project schedule and delivery timeline.",
    },
    {
      question:
        "Do you offer customized construction solutions?",
      answer:
        "Absolutely. We tailor every project according to client requirements, budget, design preferences, and future goals.",
    },
    {
      question:
        "How can I request a consultation?",
      answer:
        "You can contact us through our website, phone number, WhatsApp, or contact form to schedule a free consultation.",
    },
  ];

  const toggleFaq = (index) => {
    setActive(active === index ? null : index);
  };

  return (
    <section className="py-12 md:py-24 bg-white">
      <div className="container-custom">

        {/* Section Header */}

        <div className="text-center max-w-3xl mx-auto mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Frequently Asked Questions
          </span>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            Have Questions?
            <span className="text-[#F59E0B]">
              {" "}We've Got Answers
            </span>
          </h2>

          <p className="text-gray-600 mt-6 leading-8">
            Find answers to the most common questions about
            our construction, development, property and
            liaisoning services.
          </p>

        </div>

        {/* FAQ List */}

        <div className="max-w-4xl mx-auto">

          {faqs.map((faq, index) => (
            <div
              key={index}
              className="mb-5 border border-gray-200 rounded-2xl overflow-hidden shadow-sm"
            >

              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex justify-between items-center text-left p-4 sm:p-6 bg-white hover:bg-gray-50 transition"
              >

                <h3 className="font-semibold text-lg text-[#082B57] pr-4">
                  {faq.question}
                </h3>

                {active === index ? (
                  <FaChevronUp className="text-[#F59E0B]" />
                ) : (
                  <FaChevronDown className="text-[#F59E0B]" />
                )}

              </button>

              <div
                className={`transition-all duration-300 overflow-hidden ${
                  active === index
                    ? "max-h-96"
                    : "max-h-0"
                }`}
              >
                <div className="px-4 pb-4 sm:px-6 sm:pb-6 text-gray-600 leading-7 sm:leading-8">
                  {faq.answer}
                </div>
              </div>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default FaqSection;